import FollowUpVKA from "../../../../src/client/lta-antistolling/FollowUpVKA.js";
import * as React from 'react';
export default {
  FollowUpVKA,
  React
};